module.exports = __webpack_public_path__ + "static/media/person-3.980060ab.png";